import * as z from 'zod';

export const languageAvailableSchema = z.enum(['fr', 'fr-BE', 'nl-BE', 'es', 'ca']);

export type LanguageAvailable = z.infer<typeof languageAvailableSchema>;
